import baseFetch from '../baseFetch';

export const fetchWindWave = async (lat, lon, bwWindWaveModel, grb, userDetails = {}) =>
  baseFetch(`forecasts/legacy?lat=${lat}&lon=${lon}&model=${bwWindWaveModel}&grb=${grb}`, userDetails);

export const fetchForecasts = async (lat, lon, bwWindWaveModel, interval, bwUnitPreference, userDetails = {}, countryCode = 'US') =>
  baseFetch(`forecasts?lat=${lat}&lon=${lon}&model=${bwWindWaveModel}&interval=${interval}&units=${bwUnitPreference}`, userDetails, {
    headers: {
      'x-geo-country-iso': countryCode,
      'cf-ipcountry': countryCode,
    },
  });

export const fetchWrittenForecasts = async (lat, lon, bwWindWaveModel, bwUnitPreference, userDetails = {}, countryCode = 'US') =>
  baseFetch(`forecasts/written?lat=${lat}&lon=${lon}&model=${bwWindWaveModel}&units=${bwUnitPreference}`, userDetails, {
    headers: {
      'x-geo-country-iso': countryCode,
      'cf-ipcountry': countryCode,
    },
  });



// WEBPACK FOOTER //
// ./src/common/api/forecast.js